import { UiConfig } from '../../../../../models/assets-data/UiConfig.interface';


/**
 * Default UI configuration used as a fallback if fetching the ui-config.json assets file fails.
 * 
 * - Defines label placement styles for different forms.
 * - Contains user-facing text for page titles, buttons, modals, toasts, and loading indicators.
 * - Ensures consistency in UI messaging and layout, improving user experience.
 * - Helps maintain a fallback UI setup if dynamic configuration retrieval fails.
 * 
 * This ensures the UI config remains operational even without dynamic configuration retrieval.
 */
export const DEFAULT_ASSETS_UI: UiConfig = {
  uiConfig: {
    labelPlacement: {
      logForm: "floating",
      filterLogs: "floating",
      editLog: "stacked"
    },
    toastText: {
      logForm: {
        invalidPOInputError: "Please enter a valid PO number",
        invalidFormError: "Error in update log form"
      },
      logEntry: {
        submit: {
          success: "Log entry successfully added",
          error: "Log entry could not be added"
        },
        archiveRestore: {
          "success": "Log entry successfully restored from archive. You can find it in the main log table.",
          "error": "Log entry could not be restored from archive"
        },
        update: {
          success: "Log entry successfully updated",
          error: "Log entry could not be updated",
          noChanges: "No changes detected, log entry not updated",
          invalidFormError: "Error in update log form"
        },
        delete: {
          success: "Log entry successfully deleted",
          error: "Log entry could not be deleted"
        },
        fetch: {
          error: "Could not fetch logs"
        }
      },
      photos: {
        upload: {
          success: "Photos uploaded successfully",
          error: "Failed to upload photos",
          noPhotosError: "Please add at least one photo to the log entry"
        },
        delete: {
          single: {
            success: "Photo successfully deleted",
            error: "Photo could not be deleted"
          },
          all: {
            success: "All photos successfully deleted",
            error: "Failed to delete all photos"
          }
        },
        fetch: {
          error: "Error fetching photos"
        },
        processing: {
          success: "Photo successfully processed",
          error: "Error processing image. Please try again.",
          sizeError: "Photo exceeds size limit",
          invalidFile: "Invalid image file. Please try again.",
          uploadError: "Failed to upload image",
          readError: "Failed to read file"
        }
      },
      po: {
        validation: {
          error: "Error in validating PO",
          nonExistent: "Could not find PO"
        },
        fetch: {
          error: "Could not fetch PO data"
        }
      },
      email: {
        preview: {
          error: "Could not generate email preview"
        },
        send: {
          success: "Email sent successfully",
          error: "Failed to send email"
        }
      },
      window: {
        popoutError: "Could not open the new window. Please allow popups for this website"
      }
    },
    alertText: {
      noRecipients: {
        title: "No Recipients",
        message: "There are no recipients specified for this log entry. You can either add an email to the log row via updating the log row, or add yourself as the recipient."
      },
      noRecipientsLocation: {
        title: "No Recipients",
        message: "This email only has {{locationEmail}} as a recipient. You can either go into the log and update it with an email recipient, or continue."
      },
      poNumberType: {
        title: "PO Number Type",
        message: "Toggle if PO number contains letters",
        checkboxLabel: "Allow Letters",
        closeButton: "Close"
      }
    },
    loadingText: {
      loadingLogs: "Loading logs...",
      validatingPO: "Validating PO...",
      fetchingPOData: "Fetching PO data...",
      submittingLog: "Submitting Log...",
      updatingLog: "Updating Log Entry...",
      restoringArchivedLog: "Restoring Archived Log Entry...",
      deletingLog: "Deleting Log Entry...",
      loadingLog: "Loading log...",

      loadingPhotos: "Loading photos...",
      deletingPhoto: "Deleting photo...",
      deletingAllPhotos: "Deleting all photos...",
      processingFile: "Processing file(s)...",
      loadingEmailPreview: 'Generating email preview...',
      sendingEmailWithPhotos: 'Sending email with photos...',
      sendingEmailWithoutPhotos: 'Sending email without photos...',
 
    }
  }
};
